import React, {useEffect, useState} from "react";
import {ControlLabel, FormGroup} from "react-bootstrap";
import {debounce} from "throttle-debounce";

const DEFAULT_COLOR_MAIN = '16161B';

const CPSettingColor = ({
    name,
    label,
    defaultColor = DEFAULT_COLOR_MAIN,
    eventColor,
    onChange,
    hint = '',
}) => {
    const [color, setColor] = useState(defaultColor || '');

    useEffect(() => {
        setColor(eventColor ? `#${eventColor}` : defaultColor);
    }, [eventColor]);

    const handleChangeColor = debounce(500, (value) => {
        onChange({[name]: value.replace('#', '')});
        setColor(value);
    });

    return (
        <FormGroup>
            <FormGroup
                style={{
                    marginBottom : !!hint ? '4px' : '15px',
                    display:'flex',
                    alignItems: 'center',
                    columnGap: '12px',
                }}
            >
                <ControlLabel style={{fontWeight: 'normal'}}>
                    {label}
                </ControlLabel>
                <input
                    type="color"
                    name={name}
                    value={color}
                    onChange={(e) => handleChangeColor(e.target.value)}
                />
            </FormGroup>
            {
                !!hint &&
                <p>
                    <i>
                        ({hint})
                    </i>
                </p>
            }
        </FormGroup>
    );
};

export default CPSettingColor;
